module.exports = [{
      plugin: require('../node_modules/gatsby-plugin-manifest/gatsby-browser.js'),
      options: {"plugins":[],"name":"PepHub Consultancy","short_name":"PepHub","start_url":"/","background_color":"#faf6ef","theme_color":"#1d4ed8","display":"minimal-ui","icon":"src/assets/images/favicon.jpeg","legacy":true,"theme_color_in_head":true,"cache_busting_mode":"query","crossOrigin":"anonymous","include_favicon":true,"cacheDigest":"9833e08610f4307e4e5fc0138b053e5a"},
    },{
      plugin: require('../node_modules/gatsby/dist/internal-plugins/partytown/gatsby-browser.js'),
      options: {"plugins":[]},
    }]
